import React from "react";
import { Pill } from "@/lib/retention";
import { NONE, Pick } from "@/components/vendors/NewVendorDialog";
import { SEV, TIMER, fmtLeft, lbl, opts } from "@/lib/incidents";

export { Pill, Pick, NONE };
export { Box, Card, Empty, Head, KV, Stat } from "@/components/controls/ui";
export const SevPill = ({ s, testId }) => <Pill cls={SEV[s] || SEV.UNDER_ASSESSMENT} testId={testId}>{lbl(s)}</Pill>;
export const GenPill = ({ s, testId }) => <Pill cls="bg-slate-50 text-slate-700 border-slate-200" testId={testId}>{lbl(s)}</Pill>;
export const TimerPill = ({ t, testId }) => <Pill cls={TIMER[t?.state] || TIMER.NOT_APPLICABLE} testId={testId}>{fmtLeft(t)}</Pill>;
export const Sel = ({ o, value, onChange, testId, none, list }) => (
  <Pick value={value || NONE} onChange={(v) => onChange(v === NONE ? null : v)} testId={testId} none={none}
        options={list || opts(o)} />
);
export const Members = ({ meta, value, onChange, testId }) => (
  <Sel list={(meta?.members || []).map((m) => [m.membership_id, `${m.name} (${m.roles?.[0] || "-"})`])} value={value} onChange={onChange} testId={testId} none="Unassigned" />
);
export const Field = ({ label, children, hint }) => (
  <label className="block text-xs text-slate-600 space-y-1"><span className="font-medium">{label}</span>{children}{hint && <span className="block text-[11px] text-slate-400">{hint}</span>}</label>
);
export const TimerBar = ({ t, zone }) => {
  if (!t || t.state === "NOT_APPLICABLE") return <div className="text-xs text-slate-500" data-testid="timer-na">No 72-hour Board report timer applies (personal data not involved or not declared).</div>;
  const color = t.state === "BREACHED" ? "bg-red-600" : t.state === "COMPLETED" ? "bg-emerald-600" : t.pct > 66 ? "bg-orange-500" : "bg-[#008080]";
  return (
    <div data-testid="timer-bar" className="space-y-1">
      <div className="flex justify-between text-xs"><span className="font-semibold text-[#003366]" data-testid="timer-remaining">{fmtLeft(t)}</span>
        <span className="text-slate-500">Deadline {new Date(t.deadline).toLocaleString("en-GB", { timeZone: zone, dateStyle: "medium", timeStyle: "short" })} ({zone}) · {t.pct ?? 100}% consumed</span></div>
      <div className="h-2 bg-slate-100 rounded-full overflow-hidden"><div className={`h-full ${color} transition-[width] duration-700`} style={{ width: `${t.pct ?? 100}%` }} /></div>
      <div className="text-[11px] text-slate-400">Calculated from awareness timestamp {t.based_on} (UTC) + 72h. State: {lbl(t.state)}{t.satisfied_by ? ` - ${t.satisfied_by}` : ""}. Containment, vendor delay or drafts do not stop it.</div>
    </div>
  );
};
